import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import {
  applyThemeToDocument,
  getStoredTheme,
} from "../salon-admin/utils/theme";

import "../enterprise/executive/assets/fonts/local-fonts.css";
import "../enterprise/executive/index.css";
import "../shared/nyafazEngagementPortalSkin.css";
import "../nyafaz-ep/admin-shared/portal-file-input.css";

export default function NyafazPortalFlowLayout() {
  useEffect(() => {
    applyThemeToDocument(getStoredTheme());
    const sync = () => applyThemeToDocument(getStoredTheme());
    window.addEventListener("storage", sync);
    window.addEventListener("themechange", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("themechange", sync);
    };
  }, []);

  return <Outlet />;
}
